import { Main, Acl, Entry } from 'Pages'
import { Gijsplorer, MainSiderWrapper, EmbeddedComponentWrapper } from 'Components'
import GraphView from 'Pages/Explore/RightPanel/GraphView'
import GijsplorerPlay from 'Components/Gijsplorer/Game'

{ Login, SignUp } = Entry

export default [{
  component: () -> MainSiderWrapper(Login)
  path: '/login'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(SignUp)
  path: '/signup'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(Acl)
  path: '/acl'
  isPublic: false
}, {
  component: () -> <EmbeddedComponentWrapper Component={GraphView} />
  path: '/:spaceId?/embedded/'
  isPublic: true
}, {
  component: GijsplorerPlay
  path: '/:spaceId?/gijsplore/play'
  isPublic: true
}, {
  component: Gijsplorer
  path: '/:spaceId?/gijsplore'
  isPublic: true
}, {
  component: () -> MainSiderWrapper(Main)
  path: '/:spaceId?'
  isPublic: true
}]
